import React from 'react';
import { useTranslation } from 'react-i18next';
import { CellTypes, TableDefinition, Column } from '~/Components/DataTable/DataTable.types';
import { Avatar } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';

const useStyles = makeStyles(
  () => ({
    wrapper: {
      display: 'flex',
      alignItems: 'center',
    },
    text: {
      marginLeft: 15,
    },
  }),
  { name: 'orgStudioListTable' },
);

export const useOrgStudioListDesktopTableDefinition = (): TableDefinition => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const columns: Column[] = [
    {
      label: t('table.column.studio'),
      propertyIds: ['coverurl', 'name'],
      formatter: (values) => (
        <div className={classes.wrapper}>
          <Avatar imageUrl={values.coverurl} />
          <div className={classes.text}>{values.name}</div>
        </div>
      ),
      cellType: CellTypes.String,
    },
    {
      label: t('table.column.owner'),
      propertyIds: 'ownerFullName',
      cellType: CellTypes.String,
    },
    {
      label: t('table.column.contact'),
      propertyIds: 'ownerEmail',
      cellType: CellTypes.String,
    },
  ];

  return {
    config: { useSelectableRows: true },
    columns,
  };
};
